// src/pages/merchant/Leads.js
// Leads reçus par le marchand
// Maxula

import React, { useEffect, useState } from 'react';
import { FiInfo } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { leadAPI } from '../../services/api';

const STATUS = { new: 'bg-blue-100 text-blue-700', contacted: 'bg-yellow-100 text-yellow-700', closed: 'bg-gray-100 text-gray-600' };

const MerchantLeads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { setLoading(true); const res = await leadAPI.getMine(); setLeads(res.data?.data || []); }
    catch (e) {} finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await leadAPI.setStatus(id, status); load(); } catch (e) { toast.error('Erreur'); }
  };

  if (loading) return <div className="flex justify-center py-24"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" /></div>;

  return (
    <div className="p-6 max-w-3xl">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Contacts reçus (Leads)</h1>
      <p className="text-gray-500 mb-4">Les clients intéressés par vos offres.</p>
      <div className="mb-6 flex items-start gap-2 rounded-lg bg-blue-50 border border-blue-100 px-3 py-2 text-sm text-blue-800">
        <FiInfo className="mt-0.5 shrink-0" size={16} />
        <span>Les nouvelles demandes de contact arrivent désormais dans <strong>Messages</strong> et se répondent via Maxula. Les coordonnées des clients ne sont plus partagées.</span>
      </div>
      {leads.length === 0 ? <div className="text-center text-gray-400 py-12">Aucun contact pour le moment.</div> : (
        <div className="space-y-3">
          {leads.map((l) => (
            <div key={l._id} className="bg-white rounded-xl border border-gray-200 p-4">
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div className="font-semibold text-gray-900">{l.name}</div>
                <select value={l.status} onChange={(e) => setStatus(l._id, e.target.value)} className={`text-xs px-2 py-1 rounded-full border-0 ${STATUS[l.status]}`}>
                  <option value="new">Nouveau</option><option value="contacted">Contacté</option><option value="closed">Clôturé</option>
                </select>
              </div>
              {l.dealTitle && <div className="text-sm text-gray-500">Offre : {l.dealTitle}</div>}
              {l.message && <div className="text-sm text-gray-700 mt-1">{l.message}</div>}
              <div className="mt-2 flex flex-wrap items-center gap-4 text-sm">
                <span className="text-gray-400">{new Date(l.createdAt).toLocaleDateString('fr-FR')}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MerchantLeads;
